var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcEditWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.317 4.59643L5.10437 14.809C5.01208 14.9013 4.94547 15.0161 4.91113 15.142L3.7764 19.3027C3.62371 19.8626 4.13744 20.3763 4.69731 20.2236L8.85799 19.0889C8.98391 19.0545 9.09869 18.9879 9.19098 18.8956L19.4036 8.68304C20.1336 7.95304 20.4187 6.88904 20.1515 5.89183C19.8843 4.89463 19.1054 4.11573 18.1082 3.84853C17.111 3.58133 16.047 3.86643 15.317 4.59643ZM17.7199 5.29742C18.1995 5.42592 18.5741 5.8005 18.7026 6.28006L18.7332 6.4247C18.8015 6.86036 18.6589 7.30642 18.3429 7.62238L8.26997 17.694L5.56797 18.431L6.30497 15.729L16.3776 5.65709C16.7287 5.30603 17.2404 5.16892 17.7199 5.29742Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEditWhite);
export default __webpack_public_path__ + "static/media/ic-edit-white.867414b12c87afbb7df6608af706f311.svg";
export { ForwardRef as ReactComponent };